import React, { useState } from 'react';
import { HoursSummary, TmCascadeSummary } from './TmCascadeSummary';

export type { HoursSummary };

interface Props {
  id?: string;
  title: React.ReactNode;
  cost: number;
  sale: number;
  costLabel?: string;
  taxTag: string;
  /** Shown in collapsed header (and expanded footer when footer=true) — timesheets only */
  hours?: HoursSummary;
  children: React.ReactNode;
  defaultOpen?: boolean;
  footer?: boolean;
  className?: string;
}

export const TmCollapsibleSection: React.FC<Props> = ({
  title, cost, sale, costLabel = 'Cost', taxTag, hours, children,
  defaultOpen = true, footer = true, className = '',
}) => {
  const [open, setOpen] = useState(defaultOpen);
  const summary = (
    <TmCascadeSummary
      cost={cost}
      sale={sale}
      costLabel={costLabel}
      taxTag={taxTag}
      hours={hours}
    />
  );

  return (
    <div className={`tm-sec ${open ? '' : 'closed'} ${className}`.trim()}>
      <div className="tm-sec-head" onClick={() => setOpen(o => !o)}>
        <span className="tw">▼</span>
        {title}
        {!open && summary}
      </div>
      {open && (
        <div className="tm-sec-body">
          {children}
          {footer && (
            <div className="tm-sec-foot">
              {summary}
            </div>
          )}
        </div>
      )}
    </div>
  );
};
